import { request } from 'utils/request';
import { IRegisterUser } from './slice/types';

const authApi = {
  getUser: () => {
    return request({
      url: 'user',
    });
  },
  registerUser: (data: IRegisterUser) => {
    return request({
      method: 'POST',
      url: 'user',
      params: {
        lang: 'lt',
      },
      data,
    });
  },
  forgotPassword: (email: string) => {
    return request({
      method: 'POST',
      url: 'user/forgot-password',
      data: email,
      params: {
        lang: 'lt',
      },
    });
  },
};

export default authApi;
